import React, { Fragment, useMemo } from 'react';
import { useAppSelector, useTranslate, useWidgetsTheme as theme } from '@src/core/hooks';
import { GradientButton } from '../reusable';
import { track } from '@src/services/analytics';
import usePackageIdParam from '@src/hooks/usePackageIdParam';
import { IconShoppingCart } from '@tabler/icons-react';
import useBreakpoint from '@src/hooks/useBreakpoint';
import { dispatch } from '@src/mocks/constants';
import { productPackageSelector, addPackageToCart, productPackageStatusSelector } from '@src/features/product';
import { useWidgetId } from '@src/core/IdProvider';

const ProductPackageAddToCartButton = () => {
  const actionColor = theme('actionColor');
  const { i18n } = useTranslate();
  const packageId = usePackageIdParam()!;
  const { isDesktop } = useBreakpoint();
  const widgetId = useWidgetId();

  const productPackage = useAppSelector(productPackageSelector(packageId!));
  const status = useAppSelector(productPackageStatusSelector(packageId!));

  const handleGoForwards = () => {
    track('productPackageAddToCartClick', {
      packageId,
      productPackageName: productPackage?.name,
    });

    dispatch(addPackageToCart(widgetId));
  };

  const disabled = useMemo(() => status !== 'completed', [status]);

  return (
    <GradientButton
      disabled={disabled}
      actionColor={actionColor}
      onClick={handleGoForwards}
      fullWidth={!isDesktop}
      dataCy='productPackageAddToCartButton'
    >
      <Fragment>
        {i18n('product_package_adder_add_to_cart_button')}
        <IconShoppingCart size={20} />
      </Fragment>
    </GradientButton>
  );
};

export default ProductPackageAddToCartButton;
